import { Action } from 'redux';

import { isSpaceContentsNextPageWithTokenSuccededAction,isSpaceContentsWithTokenRequestSucceededAction } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

export function contentTotalCountReducer(
  previousState: number = 0,
  action: Action = null
): number {
  if ((isSpaceContentsWithTokenRequestSucceededAction(action) || isSpaceContentsNextPageWithTokenSuccededAction(action))
       && action?.contentWithToken?.total) {
    return action.contentWithToken.total;
  }

  return previousState;
}

